const config = {
  API_URL: import.meta.env.VITE_API_URL,
  PROD: import.meta.env.PROD,
  INVITE_COOKIE_TIMEOUT: 3600 * 24,
};

export default config;
